'use client';

import React from 'react';
import { showModal } from '@/store/reducers/ui-slice';
import { Player } from '@alien-platform/bo-core';
import { Chip, IconButton } from '@mui/material';
import { Plus } from '@phosphor-icons/react/dist/ssr/Plus';
import { useDispatch } from 'react-redux';

import { ModalDrawer, Row } from '@/types/general';
import { HorizontalTable } from '@/components/core/horizontal-table';

export function PlayerStatsTable({ playerData }: { playerData: Player | null }): React.JSX.Element {
  const dispatch = useDispatch();
  const tableData: Row[] = [
    {
      label: {
        text: 'Deposit',
      },
      value: {
        text: ``,
      },
    },
    {
      label: {
        text: 'Withdraw',
      },
      value: {
        text: ``,
      },
    },
    {
      label: {
        text: 'Free Spin',
      },
      value: {
        component: (
          <IconButton
            size="small"
            sx={{
              '&:hover': { backgroundColor: 'warning.700' },
              backgroundColor: 'warning.600',
              my: '0 !important',
              py: '0 !important',
              ml: 'auto',
            }}
          >
            <Plus color="white" />
          </IconButton>
        ),
      },
    },
    {
      label: {
        text: 'Topup Balance',
      },
      value: {
        component: (
          <IconButton
            size="small"
            sx={{
              '&:hover': { backgroundColor: 'success.700' },
              backgroundColor: 'success.600',
              my: '0 !important',
              py: '0 !important',
              ml: 'auto',
            }}
            onClick={() => {
              dispatch(
                showModal({
                  open: ModalDrawer.TOPUP,
                  content: {
                    playerId: playerData?.playerId,
                    playerCode: playerData?.playerCode,
                  },
                })
              );
            }}
          >
            <Plus color="white" />
          </IconButton>
        ),
      },
    },
    {
      label: {
        text: 'Bonus Balance',
      },
      value: {
        component: (
          <IconButton
            size="small"
            sx={{
              '&:hover': { backgroundColor: 'info.700' },
              backgroundColor: 'info.600',
              my: '0 !important',
              py: '0 !important',
              ml: 'auto',
            }}
          >
            <Plus color="white" />
          </IconButton>
        ),
      },
    },
    {
      label: {
        text: 'Cachback Balance',
      },
      value: {
        component: (
          <IconButton
            size="small"
            sx={{
              '&:hover': { backgroundColor: 'primary.700' },
              backgroundColor: 'primary.600',
              my: '0 !important',
              py: '0 !important',
              ml: 'auto',
            }}
          >
            <Plus color="white" />
          </IconButton>
        ),
      },
    },
    {
      label: {
        text: 'Bonus Claimed',
      },
      value: {
        text: ``,
      },
    },
    {
      label: {
        text: 'Cashback Claimed',
      },
      value: {
        text: '',
      },
    },
    {
      label: {
        text: 'Affiliate Balance',
      },
      value: {
        text: '',
      },
    },
    {
      label: {
        text: 'Affiliate Claimed',
      },
      value: {
        text: '',
      },
    },
    {
      label: {
        text: 'Total Wager',
      },
      value: {
        text: '',
      },
    },
    {
      label: {
        text: 'Qualified Wager',
      },
      value: {
        text: '',
      },
    },

    {
      label: {
        text: 'Total Sports Bets',
      },
      value: {
        text: '',
      },
    },
    {
      label: {
        text: 'Total Casino Bets',
      },
      value: {
        text: '',
      },
    },
    {
      label: {
        text: 'Balance',
      },
      value: {
        text: playerData?.wallet?.inUSD?.balance,
      },
    },
    {
      label: {
        text: 'GGR',
      },
      value: {
        component: (
          <Chip label="21%" sx={{ ml: 'auto', color: 'text.primary', backgroundColor: 'var(--mui-palette-divider)' }} />
        ),
      },
    },
  ];

  return <HorizontalTable tableData={tableData} />;
}
